// components/ui/StatCard.js
import React from 'react';
import { getIcon } from '../../utils/icons';

/**
 * Компонент карточки статистики
 * @param {Object} props - Свойства компонента
 * @param {string} props.title - Заголовок карточки
 * @param {number|string} props.value - Значение
 * @param {string} props.icon - Имя иконки
 * @param {string} props.color - Цвет карточки (blue, green, yellow, red)
 * @returns {JSX.Element} - Компонент для рендеринга
 */
const StatCard = ({ title, value, icon, color }) => {
  const colorClasses = {
    blue: 'bg-blue-100 text-blue-800 border-blue-200',
    green: 'bg-green-100 text-green-800 border-green-200',
    yellow: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    red: 'bg-red-100 text-red-800 border-red-200',
  };
  
  const iconColorClasses = {
    blue: 'text-blue-500',
    green: 'text-green-500',
    yellow: 'text-yellow-500',
    red: 'text-red-500',
  };

  return (
    <div className={`p-6 rounded-lg border ${colorClasses[color]} shadow-sm`}>
      <div className="flex items-center">
        <div className={`mr-4 ${iconColorClasses[color]}`}>
          {getIcon(icon)}
        </div>
        <div>
          <h3 className="text-lg font-medium">{title}</h3>
          <p className="text-2xl font-bold">{value}</p>
        </div>
      </div>
    </div>
  );
};

export default StatCard;